import React, { FC, useState } from 'react';

import { userIsRenter } from 'src/inbox/helpers';
import { ImmutableTrip } from 'src/types/trips/Trips';
import { FullBoatDetail, ImmutableSearchBoatDetails } from 'src/types/boat/BoatDetail';
import { getBoatHeadline } from 'src/common/helpers';
import getClassName from 'src/common/utils/getClassName';
import BoatPlaceholderImage from 'src/common/components/BoatPlaceholderImage';
import { NEW_TAB_ATTRIBUTES } from 'src/common/constants';
import classNames from 'classnames';
import s from './Vessel.module.scss';

type Props = {
  title?: string;
  vessel: ImmutableSearchBoatDetails;
  classNameModifier?: string;
  trip?: ImmutableTrip;
};

const Vessel: FC<Props> = ({ title, vessel, classNameModifier, trip }) => {
  const [imageLoadFailed, setImageLoadFailed] = useState(false);
  const className = getClassName(s, 'root', classNames(classNameModifier));
  const isOwner = !userIsRenter(trip);
  const vesselObj: FullBoatDetail = vessel.toJS();
  const headline = isOwner ? getBoatHeadline(vesselObj) : vessel.get('headline');
  const url = vessel.get('listing_url');
  const photoUrl = vessel.get('photo_url');

  return (
    <div className={className}>
      <a
        href={url}
        {...NEW_TAB_ATTRIBUTES}
      >
        {photoUrl && !imageLoadFailed ? (
          <img
            src={photoUrl}
            alt={headline}
            onError={() => setImageLoadFailed(true)}
            className={getClassName(s, 'image', classNames(classNameModifier))}
          />
        ) : (
          <BoatPlaceholderImage classNameModifier="vessel" />
        )}
      </a>
      <div className={getClassName(s, 'content', classNameModifier)}>
        {title && <h3 className={s.subTitle}>{title}</h3>}
        <div className={s.headlineContainer}>
          <span className={getClassName(s, 'headline', classNameModifier)}>
            {headline}
          </span>
          <a
            href={url}
            {...NEW_TAB_ATTRIBUTES}
            className={s.viewListingLink}
          >
            View Listing
          </a>
        </div>

      </div>
    </div>
  );
};

export default Vessel;
